import { render, staticRenderFns } from "./boco_inspections.vue?vue&type=template&id=0a4e4631&"
import script from "./boco_inspections.vue?vue&type=script&lang=js&"
export * from "./boco_inspections.vue?vue&type=script&lang=js&"
import style0 from "./boco_inspections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports